import { useState } from 'react';

// Dedicated destination links
const ANDAMAN_LINK = "https://travel.rethinkways.com/andaman-tour-packages/";
const BALI_LINK = "https://travel.rethinkways.com/bali-tour-packages/";
const MALDIVES_LINK = "https://travel.rethinkways.com/maldives-tour-packages/";
// New default link for all International sections (Tour, Honeymoon, Family, Escape Deals)
const INTERNATIONAL_LINK = "https://travel.rethinkways.com/destination-tour-packages/";

// Dedicated links for every International destination (same pattern as Andaman/Bali/Maldives)
const AUSTRALIA_LINK = "https://travel.rethinkways.com/australia-tour-packages/";
const BHUTAN_LINK = "https://travel.rethinkways.com/bhutan-tour-packages/";
const CAMBODIA_LINK = "https://travel.rethinkways.com/cambodia-tour-packages/";
const CANADA_LINK = "https://travel.rethinkways.com/canada-tour-packages/";
const CHINA_LINK = "https://travel.rethinkways.com/china-tour-packages/";
const DUBAI_LINK = "https://travel.rethinkways.com/dubai-tour-packages/";
const EGYPT_LINK = "https://travel.rethinkways.com/egypt-tour-packages/";
const FIJI_LINK = "https://travel.rethinkways.com/fiji-tour-packages/";
const HONGKONG_LINK = "https://travel.rethinkways.com/hong-kong-tour-packages/";
const JAPAN_LINK = "https://travel.rethinkways.com/japan-tour-packages/";
const JORDAN_LINK = "https://travel.rethinkways.com/jordan-tour-packages/";
const KAZAKHSTAN_LINK = "https://travel.rethinkways.com/kazakhstan-tour-packages/";
const KENYA_LINK = "https://travel.rethinkways.com/kenya-tour-packages/";
const LAOS_LINK = "https://travel.rethinkways.com/laos-tour-packages/";
const MALAYSIA_LINK = "https://travel.rethinkways.com/malaysia-tour-packages/";
const MAURITIUS_LINK = "https://travel.rethinkways.com/mauritius-tour-packages/";
const NEPAL_LINK = "https://travel.rethinkways.com/nepal-tour-packages/";
const NEWZEALAND_LINK = "https://travel.rethinkways.com/new-zealand-tour-packages/";
const OMAN_LINK = "https://travel.rethinkways.com/oman-tour-packages/";
const PHILIPPINES_LINK = "https://travel.rethinkways.com/philippines-tour-packages/";
const QATAR_LINK = "https://travel.rethinkways.com/qatar-tour-packages/";
const SEYCHELLES_LINK = "https://travel.rethinkways.com/seychelles-tour-packages/";
const SINGAPORE_LINK = "https://travel.rethinkways.com/singapore-tour-packages/";
const SOUTHAFRICA_LINK = "https://travel.rethinkways.com/south-africa-tour-packages/";
const SOUTHKOREA_LINK = "https://travel.rethinkways.com/south-korea-tour-packages/";
const SRILANKA_LINK = "https://travel.rethinkways.com/sri-lanka-tour-packages/";
const TANZANIA_LINK = "https://travel.rethinkways.com/tanzania-tour-packages/";
const THAILAND_LINK = "https://travel.rethinkways.com/thailand-tour-packages/";
const TURKEY_LINK = "https://travel.rethinkways.com/turkey-tour-packages/";
const USA_LINK = "https://travel.rethinkways.com/usa-tour-packages/";
const UZBEKISTAN_LINK = "https://travel.rethinkways.com/uzbekistan-tour-packages/";
const VIETNAM_LINK = "https://travel.rethinkways.com/vietnam-tour-packages/";

export const packageData = [
  {
    title: "Best India Tour Packages",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=india",
    items: [
      { name: "Andaman Tour Packages", href: ANDAMAN_LINK }, { name: "Andhra Pradesh Tour Packages" }, { name: "Arunachal Pradesh Tour Packages" },
      { name: "Assam Tour Packages" }, { name: "Bihar Tour Packages" }, { name: "Chandigarh Tour Packages" },
      { name: "Chhattisgarh Tour Packages" }, { name: "Daman and Diu Tour Packages" }, { name: "Delhi Tour Packages" },
      { name: "Goa Tour Packages" }, { name: "Gujarat Tour Packages" }, { name: "Haryana Tour Packages" },
      { name: "Himachal Pradesh Tour Packages" }, { name: "Kashmir Tour Packages" }, { name: "Jharkhand Tour Packages" },
      { name: "Karnataka Tour Packages" }, { name: "Kerala Tour Packages" }, { name: "Leh Ladakh Tour Packages" },
      { name: "Lakshadweep Tour Packages" }, { name: "Madhya Pradesh Tour Packages" }, { name: "Maharashtra Tour Packages" },
      { name: "Manipur Tour Packages" }, { name: "Meghalaya Tour Packages" }, { name: "Mizoram Tour Packages" },
      { name: "Nagaland Tour Packages" }, { name: "Odisha Tour Packages" }, { name: "Pondicherry Tour Packages" },
      { name: "Punjab Tour Packages" }, { name: "Rajasthan Tour Packages" }, { name: "Sikkim Tour Packages" },
      { name: "Tamil Nadu Tour Packages" }, { name: "Telangana Tour Packages" }, { name: "Tripura Tour Packages" },
      { name: "Uttar Pradesh Tour Packages" }, { name: "Uttarakhand Tour Packages" }, { name: "West Bengal Tour Packages" }
    ]
  },
  {
    title: "Best International Tour Packages",
    href: INTERNATIONAL_LINK,
    items: [
      { name: "Australia Tour Packages", href: AUSTRALIA_LINK }, { name: "Bali Tour Packages", href: BALI_LINK }, { name: "Bhutan Tour Packages", href: BHUTAN_LINK },
      { name: "Cambodia Tour Packages", href: CAMBODIA_LINK }, { name: "Canada Tour Packages", href: CANADA_LINK }, { name: "China Tour Packages", href: CHINA_LINK },
      { name: "Dubai Tour Packages", href: DUBAI_LINK }, { name: "Egypt Tour Packages", href: EGYPT_LINK }, { name: "Fiji Tour Packages", href: FIJI_LINK },
      { name: "Hong Kong Tour Packages", href: HONGKONG_LINK }, { name: "Japan Tour Packages", href: JAPAN_LINK }, { name: "Jordan Tour Packages", href: JORDAN_LINK },
      { name: "Kazakhstan Tour Packages", href: KAZAKHSTAN_LINK }, { name: "Kenya Tour Packages", href: KENYA_LINK }, { name: "Laos Tour Packages", href: LAOS_LINK },
      { name: "Malaysia Tour Packages", href: MALAYSIA_LINK }, { name: "Maldives Tour Packages", href: MALDIVES_LINK }, { name: "Mauritius Tour Packages", href: MAURITIUS_LINK },
      { name: "Nepal Tour Packages", href: NEPAL_LINK }, { name: "New Zealand Tour Packages", href: NEWZEALAND_LINK }, { name: "Oman Tour Packages", href: OMAN_LINK },
      { name: "Philippines Tour Packages", href: PHILIPPINES_LINK }, { name: "Qatar Tour Packages", href: QATAR_LINK }, { name: "Seychelles Tour Packages", href: SEYCHELLES_LINK },
      { name: "Singapore Tour Packages", href: SINGAPORE_LINK }, { name: "South Africa Tour Packages", href: SOUTHAFRICA_LINK }, { name: "South Korea Tour Packages", href: SOUTHKOREA_LINK },
      { name: "Sri Lanka Tour Packages", href: SRILANKA_LINK }, { name: "Tanzania Tour Packages", href: TANZANIA_LINK }, { name: "Thailand Tour Packages", href: THAILAND_LINK },
      { name: "Turkey Tour Packages", href: TURKEY_LINK }, { name: "USA Tour Packages", href: USA_LINK }, { name: "Uzbekistan Tour Packages", href: UZBEKISTAN_LINK },
      { name: "Vietnam Tour Packages", href: VIETNAM_LINK }
    ]
  },
  {
    title: "Best Europe Tour Packages",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=europe",
    items: [
      { name: "Albania Tour Packages" }, { name: "Armenia Tour Packages" }, { name: "Austria Tour Packages" },
      { name: "Azerbaijan Tour Packages" }, { name: "Belarus Tour Packages" }, { name: "Belgium Tour Packages" },
      { name: "Bulgaria Tour Packages" }, { name: "Croatia Tour Packages" }, { name: "Czech Republic Tour Packages" },
      { name: "Denmark Tour Packages" }, { name: "Estonia Tour Packages" }, { name: "Vatican City Tour Packages" },
      { name: "Finland Tour Packages" }, { name: "France Tour Packages" }, { name: "Georgia Tour Packages" },
      { name: "Germany Tour Packages" }, { name: "Greece Tour Packages" }, { name: "Hungary Tour Packages" },
      { name: "Iceland Tour Packages" }, { name: "Ireland Tour Packages" }, { name: "Italy Tour Packages" },
      { name: "Latvia Tour Packages" }, { name: "Liechtenstein Tour Packages" }, { name: "Lithuania Tour Packages" },
      { name: "Luxembourg Tour Packages" }, { name: "Malta Tour Packages" }, { name: "Montenegro Tour Packages" },
      { name: "Netherlands Tour Packages" }, { name: "North Macedonia Tour Packages" }, { name: "Norway Tour Packages" },
      { name: "Poland Tour Packages" }, { name: "Portugal Tour Packages" }, { name: "Romania Tour Packages" },
      { name: "Russia Tour Packages" }, { name: "San Marino Tour Packages" }, { name: "Serbia Tour Packages" },
      { name: "Slovakia Tour Packages" }, { name: "Slovenia Tour Packages" }, { name: "Spain Tour Packages" },
      { name: "Sweden Tour Packages" }, { name: "Switzerland Tour Packages" }, { name: "Turkey Tour Packages" },
      { name: "UK Tour Packages" }, { name: "Europe Multi-Country Tour Packages" }
    ]
  },
  {
    title: "Best Honeymoon Packages in India",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=india",
    items: [
      { name: "Andaman Honeymoon Packages", href: ANDAMAN_LINK }, { name: "Goa Honeymoon Packages" }, { name: "Himachal Pradesh Honeymoon Packages" },
      { name: "Kashmir Honeymoon Packages" }, { name: "Kerala Honeymoon Packages" }, { name: "Lakshadweep Honeymoon Packages" },
      { name: "Meghalaya Honeymoon Packages" }, { name: "Pondicherry Honeymoon Packages" }, { name: "Rajasthan Honeymoon Packages" },
      { name: "Sikkim Honeymoon Packages" }, { name: "Tamil Nadu Honeymoon Packages" }, { name: "Uttarakhand Honeymoon Packages" },
      { name: "Ooty Honeymoon Packages" }, { name: "Kodaikanal Honeymoon Packages" }, { name: "Munnar Honeymoon Packages" },
      { name: "Coorg Honeymoon Packages" }, { name: "Wayanad Honeymoon Packages" }, { name: "Nainital Honeymoon Packages" },
      { name: "Mussoorie Honeymoon Packages" }, { name: "Shimla Honeymoon Packages" }, { name: "Manali Honeymoon Packages" },
      { name: "Gulmarg Honeymoon Packages" }, { name: "Srinagar Honeymoon Packages" }, { name: "Udaipur Honeymoon Packages" }
    ]
  },
  {
    title: "Best International Honeymoon Packages",
    href: INTERNATIONAL_LINK,
    items: [
      { name: "Australia Honeymoon Packages", href: AUSTRALIA_LINK }, { name: "Bali Honeymoon Packages", href: BALI_LINK }, { name: "Dubai Honeymoon Packages", href: DUBAI_LINK },
      { name: "Fiji Honeymoon Packages", href: FIJI_LINK }, { name: "Japan Honeymoon Packages", href: JAPAN_LINK }, { name: "Malaysia Honeymoon Packages", href: MALAYSIA_LINK },
      { name: "Maldives Honeymoon Packages", href: MALDIVES_LINK }, { name: "Mauritius Honeymoon Packages", href: MAURITIUS_LINK }, { name: "New Zealand Honeymoon Packages", href: NEWZEALAND_LINK },
      { name: "Seychelles Honeymoon Packages", href: SEYCHELLES_LINK }, { name: "Singapore Honeymoon Packages", href: SINGAPORE_LINK }, { name: "South Africa Honeymoon Packages", href: SOUTHAFRICA_LINK },
      { name: "Sri Lanka Honeymoon Packages", href: SRILANKA_LINK }, { name: "Thailand Honeymoon Packages", href: THAILAND_LINK },
      { name: "Vietnam Honeymoon Packages", href: VIETNAM_LINK }
    ]
  },
  {
    title: "Best Europe Honeymoon Packages",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=europe",
    items: [
      { name: "Austria Honeymoon Packages" }, { name: "Croatia Honeymoon Packages" }, { name: "France Honeymoon Packages" },
      { name: "Greece Honeymoon Packages" }, { name: "Iceland Honeymoon Packages" }, { name: "Ireland Honeymoon Packages" },
      { name: "Italy Honeymoon Packages" }, { name: "Malta Honeymoon Packages" }, { name: "Montenegro Honeymoon Packages" },
      { name: "Netherlands Honeymoon Packages" }, { name: "Norway Honeymoon Packages" }, { name: "Portugal Honeymoon Packages" },
      { name: "Spain Honeymoon Packages" }, { name: "Switzerland Honeymoon Packages" }, { name: "Turkey Honeymoon Packages" },
      { name: "UK Honeymoon Packages" }, { name: "Europe Multi-Country Honeymoon Packages" }
    ]
  },
  {
    title: "Best India Family Tour Packages",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=india",
    items: [
      { name: "Andaman Family Tour Packages", href: ANDAMAN_LINK },{ name: "  West Bengal Family Tour Packages," }, { name: "Goa Family Tour Packages" }, { name: "Himachal Pradesh Family Tour Packages" },
      { name: "Kashmir Family Tour Packages" }, { name: "Kerala Family Tour Packages" } ,
      { name: "Meghalaya Family Tour Packages" }, { name: "Rajasthan Family Tour Packages" }, { name: "Sikkim Family Tour Packages" },
      { name: "Tamil Nadu Family Tour Packages" }, { name: "Uttarakhand Family Tour Packages" }, 
      { name: "Karnataka Family Tour Packages" }, { name: "Gujarat Family Tour Packages" }, { name: "Odisha Family Tour Packages" }
    ]
  },
  {
    title: "Best International Family Tour Packages",
    href: INTERNATIONAL_LINK,
    items: [
      { name: "Australia Family Tour Packages", href: AUSTRALIA_LINK }, { name: "Bali Family Tour Packages", href: BALI_LINK }, { name: "Bhutan Family Tour Packages", href: BHUTAN_LINK },
      { name: "Canada Family Tour Packages", href: CANADA_LINK }, { name: "Dubai Family Tour Packages", href: DUBAI_LINK }, { name: "Japan Family Tour Packages", href: JAPAN_LINK },
      { name: "Malaysia Family Tour Packages", href: MALAYSIA_LINK }, { name: "Maldives Family Tour Packages", href: MALDIVES_LINK }, { name: "Mauritius Family Tour Packages", href: MAURITIUS_LINK },
      { name: "New Zealand Family Tour Packages", href: NEWZEALAND_LINK }, { name: "Singapore Family Tour Packages", href: SINGAPORE_LINK }, { name: "South Africa Family Tour Packages", href: SOUTHAFRICA_LINK },
      { name: "Sri Lanka Family Tour Packages", href: SRILANKA_LINK }, { name: "Thailand Family Tour Packages", href: THAILAND_LINK }, { name: "USA Family Tour Packages", href: USA_LINK },
      { name: "Vietnam Family Tour Packages", href: VIETNAM_LINK }
    ]
  },
  {
    title: "Best Europe Family Tour Packages",
    href: "https://travel.rethinkways.com/travel-tour-packages/?section=europe",
    items: [
      { name: "Austria Family Tour Packages" }, { name: "France Family Tour Packages" }, { name: "Germany Family Tour Packages" },
      { name: "Greece Family Tour Packages" }, { name: "Ireland Family Tour Packages" }, { name: "Italy Family Tour Packages" },
      { name: "Netherlands Family Tour Packages" }, { name: "Norway Family Tour Packages" }, { name: "Portugal Family Tour Packages" },
      { name: "Spain Family Tour Packages" }, { name: "Switzerland Family Tour Packages" }, { name: "Turkey Family Tour Packages" },
      { name: "UK Family Tour Packages" }, { name: "Europe Multi-Country Family Tour Packages" }
    ]
  },
  {
    title: "Best India Escape Deals",
    href: "https://travel.rethinkways.com/super-deals/?cat=indian-escapes-deals",
    items: [
      { name: "Goa Escape Deals" }, { name: "Kashmir Escape Deals" }, { name: "Kerala Escape Deals" },
      { name: "Andaman Escape Deals", href: ANDAMAN_LINK }, { name: "Rajasthan Escape Deals" }, { name: "Himachal Escape Deals" },
      { name: "Uttarakhand Escape Deals" }, { name: "Ladakh Escape Deals" }, { name: "Sikkim Escape Deals" },
      { name: "Meghalaya Escape Deals" }, { name: "Ooty Escape Deals" }, { name: "Kodaikanal Escape Deals" },
      { name: "Munnar Escape Deals" }, { name: "Coorg Escape Deals" }, { name: "Pondicherry Escape Deals" },
      { name: "Darjeeling Escape Deals" }, { name: "Lakshadweep Escape Deals" }, { name: "Wayanad Escape Deals" },
      { name: "Rann of Kutch Escape Deals" }, { name: "Jaipur Escape Deals" }
    ]
  },
  {
    title: "Best International Escape Deals",
    href: INTERNATIONAL_LINK,
    items: [
      { name: "Bali Escape Deals", href: BALI_LINK }, { name: "Dubai Escape Deals", href: DUBAI_LINK }, { name: "Thailand Escape Deals", href: THAILAND_LINK },
      { name: "Singapore Escape Deals", href: SINGAPORE_LINK }, { name: "Maldives Escape Deals", href: MALDIVES_LINK }, { name: "Vietnam Escape Deals", href: VIETNAM_LINK },
      { name: "Sri Lanka Escape Deals", href: SRILANKA_LINK }, { name: "Mauritius Escape Deals", href: MAURITIUS_LINK }, { name: "Seychelles Escape Deals", href: SEYCHELLES_LINK },
      { name: "Malaysia Escape Deals", href: MALAYSIA_LINK }, { name: "Japan Escape Deals", href: JAPAN_LINK }, { name: "South Korea Escape Deals", href: SOUTHKOREA_LINK },
      { name: "Australia Escape Deals", href: AUSTRALIA_LINK }, { name: "New Zealand Escape Deals", href: NEWZEALAND_LINK }, { name: "Turkey Escape Deals", href: TURKEY_LINK },
      { name: "South Africa Escape Deals", href: SOUTHAFRICA_LINK }, { name: "Kenya Safari Escape Deals", href: KENYA_LINK }, { name: "Kazakhstan Escape Deals", href: KAZAKHSTAN_LINK },
      { name: "Uzbekistan Escape Deals", href: UZBEKISTAN_LINK }, { name: "Philippines Escape Deals", href: PHILIPPINES_LINK }
    ]
  }
];

export default function PackageAccordion() {
  const [openSections, setOpenSections] = useState(() =>
    Object.fromEntries(packageData.map((_, index) => [index, false]))
  );

  const toggleSection = (index) => {
    setOpenSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }} className="w-full !bg-white dark:!bg-black transition-colors duration-300 py-10">
      <div className="mx-auto w-full max-w-[1470px] space-y-4" style={{ maxWidth: "1470px" }}>
        {packageData.map((section, sectionIndex) => {
          const isOpen = openSections[sectionIndex];
          return (
            <div key={sectionIndex} className="border-b !border-black dark:!border-white pb-2 mb-4">
              {/* Accordion Header */}
              <button
                onClick={() => toggleSection(sectionIndex)}
                className="w-full relative flex items-center justify-center lg:justify-between py-4 focus:outline-none focus:ring-0 group"
                style={{ WebkitTapHighlightColor: 'transparent' }}
              >
                <h3 className="text-center lg:text-left px-6 lg:px-0 text-base sm:text-lg font-normal !text-black dark:!text-white transition-colors">
                  {section.title}
                </h3>

                {/* Chevron Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`absolute right-0 lg:static w-5 h-5 flex-shrink-0 !text-black dark:!text-white transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* Accordion Content (Pills) */}
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  isOpen ? 'max-h-[3000px] opacity-100 mt-2 mb-6' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="flex flex-wrap justify-center lg:justify-start gap-2.5 sm:gap-4">
                  {section.items.map((item, idx) => {
                    // Strictly B&W Pills with nuclear exclamation marks
                    const pillClassName = "inline-block py-2 px-3 sm:px-5 !border !border-black dark:!border-white rounded-lg text-xs sm:text-sm md:text-base font-light !text-black dark:!text-white !bg-transparent hover:!bg-[#D02525] hover:!border-[#D02525] hover:!text-white dark:hover:!bg-[#D02525] dark:hover:!border-[#D02525] dark:hover:!text-white transition-all duration-200 outline-none focus:outline-none focus:ring-0 no-underline";

                    // Each item uses its own dedicated link if provided (e.g. Andaman, Bali, Maldives, etc.),
                    // otherwise falls back to the section's default link.
                    const linkHref = item.href || section.href;

                    return linkHref ? (
                      <a
                        href={linkHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={idx}
                        className={pillClassName}
                        style={{ WebkitTapHighlightColor: 'transparent' }}
                      >
                        {item.name}
                      </a>
                    ) : (
                      <span key={idx} className={pillClassName} style={{ WebkitTapHighlightColor: 'transparent' }}>
                        {item.name}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}